import React from "react";

const Announcement = () => {
  return (
    <div className="container mt-4 mb-4">
      <div className="row">
        <div className="col-md-8 mx-auto">
          <div className="card-body">
            <div className="mb-3">
              <p className="fw-bold">I want to receive</p>
              <br />
              <div className="border border-2 p-4">
                <span className="form-check">
                  <input
                    type="checkbox"
                    className="form-check-input"
                    id="promotions"
                    name="promotions"
                    defaultChecked
                  />
                  <label className="form-check-label" htmlFor="promotions">
                    Promotions, course recommendations, and helpful resources
                    from Education for Home.
                  </label>
                </span>
              </div>

              <br />
              <div className="border border-2 p-4">
                <span className="form-check">
                  <input
                    type="checkbox"
                    className="form-check-input"
                    id="announcements"
                    name="announcements"
                    defaultChecked
                  />
                  <label className="form-check-label" htmlFor="announcements">
                    Announcements from instructors whose course(s) I'm enrolled
                    in.
                  </label>
                </span>
                <span className="info-text text-muted font-italic small">
                  To adjust this preference by course, leave this box checked
                  and go to the course dashboard and click on "Options" to opt
                  in or out of specific announcements.
                </span>
              </div>

              <br />

              <div className="border border-2 p-4">
                <span className="form-check mb-2">
                  <input
                    type="checkbox"
                    className="form-check-input"
                    id="no-promotional-emails"
                    name="no-promotional-emails"
                  />
                  <label
                    className="form-check-label"
                    htmlFor="no-promotional-emails"
                  >
                    Don't send me any promotional emails.
                  </label>
                </span>
                <span className="info-text text-muted font-italic small">
                  If this box is checked, please note that you will continue to
                  receive important transactional emails like purchase receipts.
                </span>
              </div>
            </div>
            <button type="submit" className="btn btn-primary">
              Save
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Announcement;
